import { useTranslation } from 'react-i18next';

import { CheckExpandable } from '@/components/CheckExpandable';
import { SectionHeader } from '@/components/SectionHeader';
import { Card, Checkbox, Form, Input } from '@arco-design/web-react';
import styled from 'styled-components';
import { GrayBox, ItemDescription, ItemTitle } from '../tools';
import { useStartupCmdStore } from './useStartupCmdStore';

const { TextArea } = Input;

export function StartupCmd() {
  const { t } = useTranslation();
  const {
    isStartupCmdSelected,
    executionCommand,
    parameters,
    tty,
    updateExecutionCommand,
    updateParameters,
    toggleStartupCmdSelected,
    updateTTY,
  } = useStartupCmdStore();

  const Header = (
    <SectionHeader
      inline
      title={t('components:startup.command')}
      description={t('components:customize.commands.run.when.container.starts')}
    />
  );
  return (
    <>
      <Card>
        <CheckExpandable
          label={Header}
          checked={isStartupCmdSelected}
          onChange={toggleStartupCmdSelected}
        >
          <Content>
            <GrayBox>
              <ItemTitle>{t('cluster:command')}</ItemTitle>
              <TextArea
                placeholder={t('components:please.enter.execution.command')}
                value={executionCommand}
                onChange={updateExecutionCommand}
              />
              <ItemDescription>
                {t('components:container.startup.command.description')}
              </ItemDescription>
            </GrayBox>
            <GrayBox>
              <ItemTitle>{t('cluster:parameters')}</ItemTitle>
              <TextArea
                placeholder={t('components:please.enter.parameters')}
                value={parameters}
                onChange={updateParameters}
              />
              <ItemDescription>
                {t('components:container.startup.command.parameters.description')}
              </ItemDescription>
            </GrayBox>
            <GrayBox>
              <Form.Item
                help={t(
                  'components:when.enabled.a.pseudo.terminal.will.be.created.when.the.container.starts.suitable.for.interactive.command.line.operations.or.debugging.scenarios',
                )}
              >
                <Checkbox checked={tty} onChange={updateTTY}>
                  {t('data-center:enable')} tty
                </Checkbox>
              </Form.Item>
            </GrayBox>
          </Content>
        </CheckExpandable>
      </Card>
    </>
  );
}

/** ============================ 样式 ==================================== */
const Content = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
